import { Report } from '@/types/ReportServiceType'
import { ILoggingService } from './LoggingService'
import axios from 'axios'

export default class ReportService {
    private readonly _logging: ILoggingService
    private readonly baseUrl = '/Report'

    constructor(logging: ILoggingService) {
        this._logging = logging
    }

    public async getReports(source: string) :Promise<Report[]> {
        const url = `${this.baseUrl}/GetReports/${source}`
        try {
            const resp= (await axios.get<{ result: Report[]}>(url)).data.result
            return resp
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async upsertReport(form: Report) : Promise<void> {
        const url = `${this.baseUrl}/UpsertReport/`
        try {
            
            await axios.post(url, {
                ...form,
            })
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async deleteReport(form: Report) : Promise<void> {
        const url = `${this.baseUrl}/DeleteReport/`
        try {
            await axios.post(url, {
                ...form,
                settings: {}
            })
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }
}